'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/TextItalic.es.js";
const e = a.forwardRef((o, a$2) => /* @__PURE__ */ a.createElement(p, { ref: a$2, ...o, weights: a$1 }));
e.displayName = "TextItalicIcon";
const s = e;
export {
  s as TextItalic,
  e as TextItalicIcon
};
